export default __webpack_public_path__ + "static/media/person_outline.f3a1407b.svg";